export const CardMolecules = [];
